export const CardMolecules = [];
